import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * The one button system (brand-vibe review 2026-07-14, "one control system").
 *
 * `buttonClasses` returns the class string so a styled <Link>/<a> can share the
 * exact same look as the <Button> element — same atom everywhere, no drift. Craft:
 * consistent height (tap-friendly), soft warm elevation on the primary, hover AND
 * press micro-states (150ms + active:scale), and a visible focus halo. Identity
 * unchanged — this is execution craft over the locked ember/neutral tokens.
 *
 * ⚠️ PROSE CONVENTION for every docblock in this package, and the reason the two
 * effects above are described rather than named: Tailwind's extractor scans these
 * files as TEXT and cannot tell a class token from an English word, so a bare
 * utility name written in a COMMENT emits a real rule into the shipped stylesheet
 * that nothing renders. Measured 2026-08-28 — the two words replaced here were
 * costing 595 bytes against a hard `size:web-ui` ceiling, and the same effect
 * accounts for ~1,486 bytes across the scanned tree. Describe the effect, or name
 * the exact class that is genuinely in use; never write the bare word.
 */
export function buttonClasses(variant = 'primary', size = 'md') {
    const base = 'inline-flex select-none items-center justify-center gap-1.5 rounded-lg font-medium transition-[background-color,border-color,transform,box-shadow] duration-150 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 focus-visible:ring-offset-1 focus-visible:ring-offset-card disabled:pointer-events-none disabled:opacity-40';
    const sizes = {
        sm: 'h-8 px-3 text-sm',
        md: 'h-10 px-4 text-[15px]',
    };
    const variants = {
        primary: 'bg-accent text-on-accent shadow-sm hover:bg-accent-deep hover:shadow-md',
        secondary: 'border border-border bg-card text-ink hover:border-accent hover:text-accent',
        ghost: 'text-accent hover:bg-accent/10',
    };
    return `${base} ${sizes[size]} ${variants[variant]}`;
}
export const Button = forwardRef(function Button({ variant, size, className, type, ...props }, ref) {
    return (_jsx("button", { ref: ref, type: type ?? 'button', className: `${buttonClasses(variant, size)}${className ? ` ${className}` : ''}`, ...props }));
});
//# sourceMappingURL=Button.js.map